<template>
  <div style="min-height: 550px;" class="sec-5" :style="{ 'background-color': details.backgroundColor}">
    <v-row
      justify="center"
      align-content="center"
      class="mx-1 fill-height"
      :class="[$vuetify.breakpoint.mdAndUp?'pdx-10':'mx-5']"
      no-gutters
    >
      <v-col cols="12" class="text-center">
        <div
          class="head font-weight-bold"
          :class="MIXIN_SETUP_UI.header"
          :style="{ color: details.color}"
          data-aos="fade-up"
        >
          {{ details.title }}
        </div>
      </v-col>

      <v-col
        cols="12" sm="6" md="4" lg="4" xl="4" 
        v-for="(plan,key) in plans"
        :key="key"
        class="d-flex my-2 pa-5"
        data-aos="fade-up"
      >
        <PlanCard
          :plan="plan"
        ></PlanCard>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { RESELLER_EVENT_BUS } from "@/views/reseller/js/ResellerEventBus";
  export default {
    name: 'ResellerPlan',
    data: () => ({
      details: {}
    }),

    components: {
      PlanCard: () => import('./PlanCard.vue'),
    },

    props: {
      plans: {
        type: Array,
        default: () => []
      }
    },

    watch: {
      resellerDetails: {
        handler: function(value) {
          if (value) {
            this.details = value.planList;
            this.show = true;
          }
        },
        immediate: true
      }
    },
    computed: {
      resellerDetails: function() {
        return RESELLER_EVENT_BUS.resellerDetails
          ? RESELLER_EVENT_BUS.resellerDetails.section
          : null;
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>